import React, { Fragment, useEffect, useRef } from 'react';
import Divider from '@mui/material/Divider';
import TextSubMenu from '../TextSubMenu';
import UserSection from '../UserSection';
import * as S from './styles';
const CustomerMenuContainer = ({ id, isDropdownOpen = false, customer, clickCallback, }) => {
    const wrapperRef = useRef(null);
    useEffect(() => {
        var _a;
        if (customer && isDropdownOpen) {
            (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [customer, isDropdownOpen]);
    if (!customer)
        return null;
    const { displayName, fullName, accountIds, subMenus, actionItems } = customer;
    const handleKeyDown = (e) => {
        var _a, _b, _c, _d;
        // collect all focusable menu items
        const items = Array.from(wrapperRef.current.querySelectorAll('[role="menuitem"]'));
        // include the wrapper as the first item
        items.unshift(wrapperRef.current);
        const idx = items.indexOf(document.activeElement);
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                (_a = items[(idx + 1) % items.length]) === null || _a === void 0 ? void 0 : _a.focus();
                break;
            case 'ArrowUp':
                e.preventDefault();
                (_b = items[(idx - 1 + items.length) % items.length]) === null || _b === void 0 ? void 0 : _b.focus();
                break;
            case 'Home':
                e.preventDefault();
                (_c = items[0]) === null || _c === void 0 ? void 0 : _c.focus();
                break;
            case 'End':
                e.preventDefault();
                (_d = items[items.length - 1]) === null || _d === void 0 ? void 0 : _d.focus();
                break;
            case 'Escape':
                e.preventDefault();
                clickCallback();
                break;
        }
    };
    return (React.createElement(S.Wrapper, { ref: wrapperRef, id: `menu-${id}`, role: "menu", tabIndex: 0, onKeyDown: handleKeyDown, onBlur: (e) => {
            const next = e.relatedTarget;
            if (!e.currentTarget.contains(next)) {
                clickCallback();
            }
        }, onClick: () => {
            clickCallback();
        } },
        React.createElement(S.InfoSection, { role: "menuitem", tabIndex: -1 },
            React.createElement(UserSection, { isDropdownOpen: isDropdownOpen, displayName: displayName, fullName: fullName, accountIds: accountIds })),
        subMenus && (React.createElement(S.SubMenus, null,
            React.createElement(Divider, null),
            React.createElement(S.MenuSection, null, subMenus.map((item) => item ? (React.createElement(Fragment, { key: item.id },
                React.createElement(TextSubMenu, { item: item, clickCallback: clickCallback }))) : null)),
            React.createElement(Divider, null))),
        React.createElement(S.ActionSections, null, actionItems.map((item) => (React.createElement(Fragment, { key: item.id },
            React.createElement(S.ActionButton, { role: "menuitem", tabIndex: -1, variant: "outlined", size: "small", onClick: () => {
                    if (item.callback)
                        item.callback();
                    clickCallback();
                } }, item.title)))))));
};
export default CustomerMenuContainer;
//# sourceMappingURL=index.js.map